import { actions as LKModalActions } from 'shared/LKModal'
import { MODAL_NAME } from './constants'

export const open = (args) => LKModalActions.open({ name: MODAL_NAME, ...args })
